import { loadBing } from "src/vendor/bing";
import { registerHandler } from "../handler";

export default function registerHandlers() {
  registerHandler("lead", () => {
    loadBing().then((bing) => {
      bing.push({
        ec: "Lead",
        ea: "Lead",
        el: "Lead",
        ev: "0",
      });
    });
  });

  registerHandler("initiateCheckout", () => {
    loadBing().then((bing) => {
      bing.push({
        ec: "Initiate Checkout",
        ea: "Initiate Checkout",
        el: "Initiate Checkout",
        ev: "0",
      });
    });
  });

  registerHandler("purchase", ({ order }) => {
    loadBing().then((bing) => {
      bing.push({
        ec: "Purchase",
        ea: "Purchase",
        el: "Purchase",
        ev: "0",
        gv: order.erev_9_months.toFixed(3),
        gc: "USD",
      });
    });
  });
}
